// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pvtUi {
    color: #2a3f5f;
    font-family: Verdana;
    border-collapse: collapse;
}
.pvtUi select {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
}

.pvtUi td.pvtOutput {
    vertical-align: top;
}

table.pvtTable {
    font-size: 8pt;
    text-align: left;
    border-collapse: collapse;
    margin-top: 3px;
    margin-left: 3px;
    font-family: Verdana;
}
table.pvtTable thead tr th,
table.pvtTable tbody tr th {
    background-color: #fff;
    border: 1px solid #c8d4e3;
    font-size: 8pt;
    padding: 5px;
}

table.pvtTable .pvtColLabel {
    text-align: center;
}
table.pvtTable .pvtTotalLabel {
    text-align: right;
}

table.pvtTable tbody tr td {
    color: #2a3f5f;
    padding: 5px;
    background-color: #fff;
    border: 1px solid #c8d4e3;
    vertical-align: top;
    text-align: right;
}

.pvtTable .pvtTotalLabel {
    display: none;
}

.pvtTable tr td:last-child {
    visibility: hidden;
    display: none; 
}

.pvtTable tbody tr:last-child {
    visibility: hidden; 
    display: none;
}

.pvtTotal,
.pvtGrandTotal {
    font-weight: bold;
}

.pvtRowOrder,
.pvtColOrder {
    cursor: pointer;
    width: 15px;
    margin-left: 5px;
    display: inline-block;
    user-select: none;
    text-decoration: none !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
}

.pvtAxisContainer,
.pvtVals {
    border: 1px solid #a2b1c6;
    background: #f2f5fa;
    padding: 5px;
    min-width: 20px;
    min-height: 20px;
}

.pvtRenderers {
    padding-left: 5px;
    -webkit-user-select: none;
            user-select: none;
}

.pvtDropdown {
    display: inline-block;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    margin: 3px;
}

.pvtDropdownIcon {
    float: right;
    color: #a2b1c6;
}
.pvtDropdownCurrent {
    text-align: left;
    border: 1px solid #a2b1c6;
    border-radius: 4px;
    display: inline-block;
    position: relative;
    width: 210px;
    box-sizing: border-box;
    background: white;
}

.pvtDropdownCurrentOpen {
    border-radius: 4px 4px 0 0;
}

.pvtDropdownMenu {
    background: white;
    position: absolute;
    width: 100%;
    margin-top: -1px;
    border-radius: 0 0 4px 4px;
    border: 1px solid #a2b1c6;
    border-top: 1px solid #dfe8f3;
    box-sizing: border-box;
}

.pvtDropdownValue {
    padding: 2px 5px;
    font-size: 12px;
    text-align: left;
}
.pvtDropdownActiveValue {
    background: #ebf0f8;
}

.pvtVals {
    text-align: center;
    white-space: nowrap;
    vertical-align: top;
    padding-bottom: 12px;
}

.pvtRows {
    height: 35px;
}

.pvtAxisContainer li {
    padding: 8px 6px;
    list-style-type: none;
    cursor: move;
}
.pvtAxisContainer li.pvtPlaceholder {
    -webkit-border-radius: 5px;
    padding: 3px 15px;
    border-radius: 5px;
    border: 1px dashed #a2b1c6;
}
.pvtAxisContainer li.pvtPlaceholder span.pvtAttr {
    display: none;
}

.pvtAxisContainer li span.pvtAttr {
    -webkit-text-size-adjust: 100%;
    background: #f3f6fa;
    border: 1px solid #c8d4e3;
    padding: 2px 5px;
    white-space: nowrap;
    border-radius: 5px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
}

.pvtTriangle {
    cursor: pointer;
    color: #506784;
}

.pvtHorizList li {
    display: inline-block;
}
.pvtVertList {
    vertical-align: top;
}

.pvtFilteredAttribute {
    font-style: italic;
}

.sortable-chosen .pvtFilterBox {
    display: none !important;
}

.pvtCloseX {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 18px;
    cursor: pointer;
    text-decoration: none !important;
}

.pvtDragHandle {
    position: absolute;
    left: 5px;
    top: 5px;
    font-size: 18px;
    cursor: move;
    color: #a2b1c6;
}

.pvtButton {
    color: #506784;
    border-radius: 5px;
    padding: 3px 6px;
    background: #f2f5fa;
    border: 1px solid;
    border-color: #c8d4e3;
    font-size: 14px;
    margin: 3px;
    transition: 0.34s all cubic-bezier(0.19, 1, 0.22, 1);
    text-decoration: none !important;
}

.pvtButton:hover {
    background: #e2e8f0;
    border-color: #a2b1c6;
}

.pvtButton:active {
    background: #d1dae6;
}

.pvtFilterBox input {
    border: 1px solid #c8d4e3;
    border-radius: 5px;
    color: #506784;
    padding: 0 3px;
    font-size: 14px;
}

.pvtFilterBox input:focus {
    border-color: #119dff;
    outline: none;
}

.pvtFilterBox {
    z-index: 100;
    width: 300px;
    border: 1px solid #506784;
    background-color: #fff;
    position: absolute;
    text-align: center;
    user-select: none;
    min-height: 100px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
}

.pvtFilterBox h4 {
    margin: 15px;
}
.pvtFilterBox p {
    margin: 10px auto;
}
.pvtFilterBox button {
    color: #2a3f5f;
}
.pvtFilterBox input[type='text'] {
    width: 230px;
    color: #2a3f5f;
    margin-bottom: 5px;
}

.pvtCheckContainer {
    text-align: left;
    font-size: 14px;
    white-space: nowrap;
    overflow-y: scroll;
    width: 100%;
    max-height: 30vh;
    border-top: 1px solid #dfe8f3;
}

.pvtCheckContainer p {
    margin: 0;
    margin-bottom: 1px;
    padding: 3px;
    cursor: default;
}

.pvtCheckContainer p.selected {
    background: #ebf0f8;
}

.pvtOnly {
    display: none;
    width: 35px;
    float: left;
    font-size: 12px;
    padding-left: 5px;
    cursor: pointer;
}

.pvtOnlySpacer {
    display: block;
    width: 35px;
    float: left;
}

.pvtCheckContainer p:hover .pvtOnly {
    display: block;
}
.pvtCheckContainer p:hover .pvtOnlySpacer {
    display: none;
}

.pvtRendererArea {
    padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Report/ReportProjected/ReportProjectedPivotData/Pivot.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;AACA;;IAEI,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,gCAAgC;IAChC,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IAEjB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IAGnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,oDAAoD;IACpD,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".pvtUi {\n    color: #2a3f5f;\n    font-family: Verdana;\n    border-collapse: collapse;\n}\n.pvtUi select {\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n}\n\n.pvtUi td.pvtOutput {\n    vertical-align: top;\n}\n\ntable.pvtTable {\n    font-size: 8pt;\n    text-align: left;\n    border-collapse: collapse;\n    margin-top: 3px;\n    margin-left: 3px;\n    font-family: Verdana;\n}\ntable.pvtTable thead tr th,\ntable.pvtTable tbody tr th {\n    background-color: #fff;\n    border: 1px solid #c8d4e3;\n    font-size: 8pt;\n    padding: 5px;\n}\n\ntable.pvtTable .pvtColLabel {\n    text-align: center;\n}\ntable.pvtTable .pvtTotalLabel {\n    text-align: right;\n}\n\ntable.pvtTable tbody tr td {\n    color: #2a3f5f;\n    padding: 5px;\n    background-color: #fff;\n    border: 1px solid #c8d4e3;\n    vertical-align: top;\n    text-align: right;\n}\n\n.pvtTable .pvtTotalLabel {\n    display: none;\n}\n\n.pvtTable tr td:last-child {\n    visibility: hidden;\n    display: none; \n}\n\n.pvtTable tbody tr:last-child {\n    visibility: hidden; \n    display: none;\n}\n\n.pvtTotal,\n.pvtGrandTotal {\n    font-weight: bold;\n}\n\n.pvtRowOrder,\n.pvtColOrder {\n    cursor: pointer;\n    width: 15px;\n    margin-left: 5px;\n    display: inline-block;\n    user-select: none;\n    text-decoration: none !important;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n}\n\n.pvtAxisContainer,\n.pvtVals {\n    border: 1px solid #a2b1c6;\n    background: #f2f5fa;\n    padding: 5px;\n    min-width: 20px;\n    min-height: 20px;\n}\n\n.pvtRenderers {\n    padding-left: 5px;\n    user-select: none;\n}\n\n.pvtDropdown {\n    display: inline-block;\n    position: relative;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    margin: 3px;\n}\n\n.pvtDropdownIcon {\n    float: right;\n    color: #a2b1c6;\n}\n.pvtDropdownCurrent {\n    text-align: left;\n    border: 1px solid #a2b1c6;\n    border-radius: 4px;\n    display: inline-block;\n    position: relative;\n    width: 210px;\n    box-sizing: border-box;\n    background: white;\n}\n\n.pvtDropdownCurrentOpen {\n    border-radius: 4px 4px 0 0;\n}\n\n.pvtDropdownMenu {\n    background: white;\n    position: absolute;\n    width: 100%;\n    margin-top: -1px;\n    border-radius: 0 0 4px 4px;\n    border: 1px solid #a2b1c6;\n    border-top: 1px solid #dfe8f3;\n    box-sizing: border-box;\n}\n\n.pvtDropdownValue {\n    padding: 2px 5px;\n    font-size: 12px;\n    text-align: left;\n}\n.pvtDropdownActiveValue {\n    background: #ebf0f8;\n}\n\n.pvtVals {\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: top;\n    padding-bottom: 12px;\n}\n\n.pvtRows {\n    height: 35px;\n}\n\n.pvtAxisContainer li {\n    padding: 8px 6px;\n    list-style-type: none;\n    cursor: move;\n}\n.pvtAxisContainer li.pvtPlaceholder {\n    -webkit-border-radius: 5px;\n    padding: 3px 15px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n    border: 1px dashed #a2b1c6;\n}\n.pvtAxisContainer li.pvtPlaceholder span.pvtAttr {\n    display: none;\n}\n\n.pvtAxisContainer li span.pvtAttr {\n    -webkit-text-size-adjust: 100%;\n    background: #f3f6fa;\n    border: 1px solid #c8d4e3;\n    padding: 2px 5px;\n    white-space: nowrap;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n}\n\n.pvtTriangle {\n    cursor: pointer;\n    color: #506784;\n}\n\n.pvtHorizList li {\n    display: inline-block;\n}\n.pvtVertList {\n    vertical-align: top;\n}\n\n.pvtFilteredAttribute {\n    font-style: italic;\n}\n\n.sortable-chosen .pvtFilterBox {\n    display: none !important;\n}\n\n.pvtCloseX {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    font-size: 18px;\n    cursor: pointer;\n    text-decoration: none !important;\n}\n\n.pvtDragHandle {\n    position: absolute;\n    left: 5px;\n    top: 5px;\n    font-size: 18px;\n    cursor: move;\n    color: #a2b1c6;\n}\n\n.pvtButton {\n    color: #506784;\n    border-radius: 5px;\n    padding: 3px 6px;\n    background: #f2f5fa;\n    border: 1px solid;\n    border-color: #c8d4e3;\n    font-size: 14px;\n    margin: 3px;\n    transition: 0.34s all cubic-bezier(0.19, 1, 0.22, 1);\n    text-decoration: none !important;\n}\n\n.pvtButton:hover {\n    background: #e2e8f0;\n    border-color: #a2b1c6;\n}\n\n.pvtButton:active {\n    background: #d1dae6;\n}\n\n.pvtFilterBox input {\n    border: 1px solid #c8d4e3;\n    border-radius: 5px;\n    color: #506784;\n    padding: 0 3px;\n    font-size: 14px;\n}\n\n.pvtFilterBox input:focus {\n    border-color: #119dff;\n    outline: none;\n}\n\n.pvtFilterBox {\n    z-index: 100;\n    width: 300px;\n    border: 1px solid #506784;\n    background-color: #fff;\n    position: absolute;\n    text-align: center;\n    user-select: none;\n    min-height: 100px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n}\n\n.pvtFilterBox h4 {\n    margin: 15px;\n}\n.pvtFilterBox p {\n    margin: 10px auto;\n}\n.pvtFilterBox button {\n    color: #2a3f5f;\n}\n.pvtFilterBox input[type='text'] {\n    width: 230px;\n    color: #2a3f5f;\n    margin-bottom: 5px;\n}\n\n.pvtCheckContainer {\n    text-align: left;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow-y: scroll;\n    width: 100%;\n    max-height: 30vh;\n    border-top: 1px solid #dfe8f3;\n}\n\n.pvtCheckContainer p {\n    margin: 0;\n    margin-bottom: 1px;\n    padding: 3px;\n    cursor: default;\n}\n\n.pvtCheckContainer p.selected {\n    background: #ebf0f8;\n}\n\n.pvtOnly {\n    display: none;\n    width: 35px;\n    float: left;\n    font-size: 12px;\n    padding-left: 5px;\n    cursor: pointer;\n}\n\n.pvtOnlySpacer {\n    display: block;\n    width: 35px;\n    float: left;\n}\n\n.pvtCheckContainer p:hover .pvtOnly {\n    display: block;\n}\n.pvtCheckContainer p:hover .pvtOnlySpacer {\n    display: none;\n}\n\n.pvtRendererArea {\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
